import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';
import { paginationSelectSx } from './StoryListTablePagination.styles';

export const styles = createTypedSxStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray200}`,
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: capitalDesignTokens.foundations.colors.white,
  },
  container: {
    overflowY: 'auto',
    padding: '16px 16px 0 16px',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '16px',
    paddingBottom: '16px',
  },
  card: {
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${capitalDesignTokens.foundations.colors.gray200}`,
    borderRadius: '8px',
    overflow: 'hidden',
    '&:hover': {
      boxShadow: 4
    }
  },
  cardHeader: {
    height: '80px',
    alignItems: 'flex-start',
    padding: '12px 16px',
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
    },
    '& .MuiCardHeader-title': {
      fontSize: '16px',
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiCardHeader-subheader': {
      fontSize: '12px',
      marginTop: '4px',
    },
  },
  cardMedia: {
    objectFit: 'cover',
    width: '100%',
    height: '160px',
    objectPosition: 'center'
  },
  cardMediaPlaceholder: {
    width: '100%',
    height: '160px',
    backgroundColor: capitalDesignTokens.foundations.colors.gray100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardMediaPlaceholderIcon: {
    fontSize: '32px',
    color: capitalDesignTokens.foundations.colors.gray400,
  },
  paginationWrapper: {
    borderTop: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    position: 'sticky',
    bottom: 0,
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    zIndex: 1,
    ...paginationSelectSx,
  }
});
